import { ApiService } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

type GetArgs = Parameters<typeof ApiService.caseWithWorkWorkProcess>[0];
export const getCaseForWork = createAsyncSaga(
  LIS.WORK.GET_CASE.REQUEST,
  LIS.WORK.GET_CASE.SUCCESS,
  LIS.WORK.GET_CASE.ERROR,
  (args: GetArgs) => `work/${args.id}/case`,
  (args: GetArgs) => ApiService.caseWithWorkWorkProcess(args)
) as AsyncSagaAction<GetArgs>;
